<h1 *ngIf="!embedded" mat-dialog-title class="dialog-title-row">
	<span i18n>User Roles <small class="align-top">- {{dialogData.user.email}}</small></span>

	<button
		mat-icon-button
		type="button"
		class="refresh-icon-button"
		(click)="getRolesSources()"
		matTooltip="Refresh role sources"
		i18n-matTooltip
		aria-label="Refresh role sources"
	>
		<mat-icon>refresh</mat-icon>
	</button>
</h1>

<div *ngIf="embedded" class="dialog-title-row mb-2">
	<h2 class="mb-0" i18n>User Roles Sources</h2>
	<button
		mat-icon-button
		type="button"
		class="refresh-icon-button"
		(click)="getRolesSources()"
		matTooltip="Refresh role sources"
		i18n-matTooltip
		aria-label="Refresh role sources"
	>
		<mat-icon>refresh</mat-icon>
	</button>
</div>
<div>
	<p>This reflects Data sources for SIS Roles. It does not include Entra Roles, which are decorated into the JWT on Employee SSO.</p>
</div>

	<div [attr.mat-dialog-content]="embedded ? null : ''" class="main-content">
		<div class="row">
			<div class="col-12 mb-3">
				<section>
					<h3>Cognito Roles</h3>
					<ul>
						<li *ngFor="let role of roleSources.cognito">{{ role }}</li>
						<li *ngIf="!roleSources.cognito?.length"><em>No roles</em></li>
					</ul>
				</section>
			</div>

			<div class="col-12 mb-3">
				<section>
					<h3>DynamoDB UserRoles</h3>
					<ul>
						<li *ngFor="let role of roleSources.dynamoDBUserRole">{{ role }}</li>
						<li *ngIf="!roleSources.dynamoDBUserRole?.length"><em>No roles</em></li>
					</ul>
				</section>
			</div>

			<div class="col-12 mb-3">
				<section>
					<h3>DynamoDB UserIdentityMap.roles</h3>
					<ul>
						<li *ngFor="let role of roleSources.dynamoDBUserIdentityMap">{{ role }}</li>
						<li *ngIf="!roleSources.dynamoDBUserIdentityMap?.length"><em>No roles</em></li>
					</ul>
				</section>
			</div>

			<div class="col-12 mb-3">
				<section>
					<h3>SIS View - What SIS logic believes</h3>
					<ul>
						<li *ngFor="let role of roleSources.sis">{{ role }}</li>
						<li *ngIf="!roleSources.sis?.length"><em>No roles</em></li>
					</ul>
				</section>
			</div>
		</div>
	</div>

	<div *ngIf="!embedded" mat-dialog-actions class="row ss">
		<div class="col-12 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
				type="button"
			>Close</button>
		</div>
	</div>


